<div class="flex flex-col gap-4">
  <barcode-scanner-search-field (onCode)="codeScanned($event)"></barcode-scanner-search-field>

  <div class="flex flex-col gap-2 bg-neutral-800 rounded-sm p-2">
    <div class="flex flex-row gap-4 items-center">
      <div class="text-lg font-bold">{{ 'internal.inventory.items' | translate }}</div>
    </div>

    <div class="h-1 bg-neutral-950"></div>

    <div class="flex flex-col gap-2">
      @if (loadingItems()) {
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
      } @else {
        @for (item of filteredItems(); track item._id) {
          <div
            class="item pt-2 rounded-sm"
            [class.returned]="itemComplete(item._id)"
            [class.shaking]="typeShaking(item._id)"
            #typeElements
          >
            <div
              class="flex flex-row items-center gap-2 cursor-pointer"
              (click)="toggleCollapse(item._id)"
            >
              <mat-icon color="white">
                {{ collapsedTypes()[item._id] ? 'expand_more' : 'expand_less' }}
              </mat-icon>
              <span class="item-count">{{ itemTypesCount()[item._id] }}x </span>
              <span class="font-semibold">{{ item.name }}</span>
              @if (item.additionalInfo) {
                <div class="ml-4 text-sm text-muted-color">{{ item.additionalInfo }}</div>
              }
            </div>
            <div
              class="instance-list flex flex-col mt-2 ml-4"
              [class.collapsed]="collapsedTypes()[item._id]"
            >
              @for (instance of filteredInstances(item); track instance.itemid) {
                <div
                  class="instance flex flex-row items-center h-9 rounded-sm"
                  [class.returned]="instanceFound(item._id, instance.itemid)"
                  [class.deleted]="instanceDeleted(item._id, instance.itemid)"
                  [class.booked]="instanceBooked(item._id, instance.itemid) && !instanceFound(item._id, instance.itemid)"
                  [class.shaking]="instanceShaking(item._id, instance.itemid)"
                  [attr.id]="item._id + '-' + instance.itemid"
                  #instanceElements
                >
                  <div class="ml-2 text-base font-semibold">{{ item.name }}</div>
                  <div class="ml-4 text-sm text-muted-color">{{ instance.itemid }}</div>
                  <div class="ml-4">{{instanceStatus(item._id, instance.itemid) | translate}}</div>

                  @if (instanceDeleted(item._id, instance.itemid)) {
                    <div class="ml-4">{{ 'internal.inventory.deleted' | translate }}</div>
                  }
                  <div class="ml-auto flex flex-row justify-end items-center gap-2">
                    <p-button
                      [pt]="{ root: { style: { padding: '4px' } } }"
                      [rounded]="true"
                      [text]="true"
                      (onClick)="printLabel(item, instance)"
                    >
                      <mat-icon color="white"> print </mat-icon>
                    </p-button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'internal.inventory.inventoryCheck.clearCheckpoint' | translate"
    severity="warn"
    (onClick)="clearCheckpoint()"
  />
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
  <p-button
    [label]="'general.save' | translate"
    severity="primary"
    (onClick)="save()"
  />
</div>
